import Reveal from "@/components/feature/Reveal";
import SectionTitle from "@/components/feature/SectionTitle";
import CroppedImage from "@/components/feature/CroppedImage";
import { reformGroups, reformWorks } from "@/mocks/reform";
import MascotAccent from "@/components/feature/MascotAccent";

export default function Cases() {
  return (
    <section id="cases" className="relative overflow-hidden bg-background-50 py-16 md:py-24">
      <MascotAccent variant="work" className="bottom-10 right-5 hidden h-20 w-20 xl:block" />
      <div className="site-container">
        <Reveal>
          <SectionTitle
            upper="REFORM"
            under="株式会社小林建設は、春日部市で屋根工事・塗装工事を中心に住宅リフォームを行っている建設会社です。片付け後に必要になった工事もご相談いただけます。"
          >
            リフォーム事業のご紹介
          </SectionTitle>
        </Reveal>

        <div className="mt-12 grid gap-6 md:grid-cols-3">
          {reformGroups.map((group, i) => (
            <Reveal key={group.title} delay={i * 70}>
              <div className="h-full rounded-lg border border-background-200 bg-background-100/70 p-5">
                <div className="flex items-center gap-3">
                  <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-500 text-background-50">
                    <i className={`${group.icon} text-xl`} />
                  </span>
                  <h3 className="font-heading text-lg font-black text-foreground-950">{group.title}</h3>
                </div>
                <ul className="mt-4 flex flex-wrap gap-1.5">
                  {group.items.map((item) => (
                    <li
                      key={item}
                      className="rounded-md border border-background-200 bg-background-50 px-3 py-1.5 text-sm font-bold text-foreground-700"
                    >
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={80}>
          <div className="mt-6 grid gap-5 md:grid-cols-3">
            {reformWorks.map((work) => (
              <div key={work.label} className="min-w-0 overflow-hidden rounded-lg border border-background-200 bg-background-50">
                <div className="p-2.5 pb-0">
                  <div className="w-full overflow-hidden rounded-lg border border-background-200 bg-background-50">
                    {work.photo ? (
                      <CroppedImage
                        src={work.photo.src}
                        alt={`${work.label}の施工写真`}
                        x={work.photo.x}
                        y={work.photo.y}
                        w={work.photo.w}
                        h={work.photo.h}
                        ratio={work.photo.ratio}
                        className="block w-full"
                      />
                    ) : (
                      <img
                        src={work.img}
                        alt={`${work.label}のイメージ`}
                        className="block aspect-[4/3] w-full object-cover object-top"
                      />
                    )}
                  </div>
                </div>
                <div className="p-4">
                  <p className="inline-flex rounded-full bg-primary-100 px-2.5 py-1 text-[11px] font-bold text-primary-800">
                    {work.label}
                  </p>
                  <p className="mt-2 text-base font-bold text-foreground-800">{work.caption}</p>
                </div>
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal delay={120}>
          <p className="mt-4 flex items-start gap-2 text-sm leading-relaxed text-foreground-500">
            <i className="ri-information-line mt-0.5" />
            掲載写真はイメージです。実際の施工写真・施工事例は、案件が増え次第順次追加してまいります。
          </p>
        </Reveal>
      </div>
    </section>
  );
}